import React from 'react';
import RatingIndicator from "../RatingIndicator";
import styles from "../../../assets/styles/cardNews/TimelineCard.module.css";
import PressNDate from "./PressNDate";

const TimelineCard = ({news, main, color}) => {

    return (
        <div className={`${styles.card_container} ${main}`} style={{backgroundColor:color,  border:!!color ? 'none': ''}}>
            <div className={styles.card_top}>
                <RatingIndicator signal={news.staticsentimental.signal}/>
                <PressNDate press={news.press} date={news.registdate}/>
            </div>
            <div className={styles.card_contents}>
                <div>
                    <div className={styles.card_news}>
                        <p className={`${styles.title} ${main}`}>{news.subject}</p>
                        <p className={styles.summary}>{news.summary}</p>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default TimelineCard;
